import React from "react";
import withRouter from "../../Components/Common/withRouter";

const ParticlesAuth = ({ children }) => {
  return (
    <React.Fragment>
      <div className="auth-page-wrapper">
        

        {/* pass the children */}
        {children}

       
      </div>
    </React.Fragment>
  );
};

export default withRouter(ParticlesAuth);
